import { IProductFileWithFile } from "@evennt-tech/api-v2-core";
import { useCustomProductOptionStore } from "store/custom-product-option/custom-product-option-shop.store";

export const useCustomProductOptionShopStoreActions = () => {
  return useCustomProductOptionStore(({ setFromProducts, reset }) => ({
    setFromProducts,
    reset,
  }));
};

export const useCustomProductOptionShopStoreState = () =>
  useCustomProductOptionStore(({ productConfigsBySupplier }) => ({
    productConfigsBySupplier,
  }));

export const useProductConfigs = (
  supplierCompanyId: string,
  productId: string
) =>
  useCustomProductOptionStore(
    ({ productConfigsBySupplier }) =>
      productConfigsBySupplier?.get(supplierCompanyId)?.get(productId)
        ?.configs ?? null
  );

// One empty list for every product without files: a fresh `[]` per call
// re-renders the consumer on every store update and breaks its memos.
const NO_FILES: IProductFileWithFile[] = [];

export const useProductFiles = (supplierCompanyId: string, productId: string) =>
  useCustomProductOptionStore(
    ({ productConfigsBySupplier }) =>
      productConfigsBySupplier?.get(supplierCompanyId)?.get(productId)?.files ??
      NO_FILES
  );
